module.exports = __webpack_public_path__ + "static/media/map-marker-icon.98930f0b.png";